import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';

@Component({
  selector: 'sbnb-signup-user-header',
  templateUrl: './signup-user-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignupUserHeaderComponent {
  @HostBinding('class') class = 'block';
  @Input() isReturning = false;

  constructor(public signupUserService: SignupUserService) {}
}
